export default "__VITE_ASSET__h3oOmm2t__"